export default "__VITE_ASSET__Riq02vmA__"